export class Constants {
  // Generic Constants
  public static readonly activeCapability: string = "activeCapability";
  public static readonly capability: string = "capability";
  public static readonly capabilityId: string = "capabilityId";
  public static readonly capabilityName: string = "capabilityName";
  public static readonly Designcenter: string = "Designcenter";
  public static readonly Teamcenter: string = "Teamcenter";
  public static readonly capabilityDetails: string = "capabilityDetails";
  public static readonly defaultCapabilityId: string = "000";
  public static readonly defaultCapabilityName: string = "dummy-capability";
  public static readonly defaultTabComponent: string = "DummyCapability";
  public static readonly defaultToolbarComponent: string = "DummyToolbar";
  public static readonly redirect: string = "redirect";
  public static readonly cacheTeamcenterCode: string = "teamcenterCode";
  public static readonly cacheConfiguration: string = "configuration";
  public static readonly cacheUserConfiguration: string = "userconfiguration";
  public static readonly cacheTeamcenterLanguage: string = "teamcenterLanguage";
  public static readonly cacheSelectedSite: string = "selectedSite";
  public static readonly cacheSiteId: string = "siteId";
  public static readonly cacheAppDeploymentId: string = "appDeploymentId";
  public static readonly cacheSiteDisplay: string = "siteDisplay";
  public static readonly cacheAppName: string = "appName";
  public static readonly cacheTcVersion: string = "tcVersion";
  public static readonly cachePolarionCode: string = "polarionCode";
  public static readonly oploginSSO: string = "auth/loginsso";
  public static readonly opgetOnboardedStatus: string = "onboardedstatus";
  public static readonly authorizerType: string = "authorizerType";
  public static readonly samLoginUrl: string = "samLoginUrl";
  public static readonly accessToken: string = "accessToken";
  public static readonly refreshToken: string = "refreshToken";
  public static readonly SAMAuthentication: string = "SAM";
  public static readonly SAM2Authentication: string = "SAM2.0";
  public static readonly NonSAMAuthentication: string = "NON SAM";
  public static readonly tokenSid: string = "tokenSid";
  public static readonly opConfiguration: string = "configuration";
  public static readonly opgetSiteCapability: string = "capability";
  public static readonly opUserConfiguration: string = "userconfiguration";
  public static readonly opGetSessionanalyticsInfo: string = "sessionanalytics";
  public static readonly tenantTelemetryOptIn: string = "tenantTelemetryOptIn";
  public static readonly userProductExcellenceTelemetryOptIn: string =
    "userProductExcellenceTelemetryOptIn";
  public static readonly userDigitalProductTelemetryOptIn: string =
    "userDigitalProductTelemetryOptIn";
  public static readonly accept: string = "Accept";
  public static readonly decline: string = "Decline";
  public static readonly defaultMobileToolbarComponentRow1: string =
    "DummyMobileToolbarRow1";
  public static readonly defaultMobileToolbarComponentRow2: string =
    "DummyMobileToolbarRow2";
  public static readonly opgetBaseChangeTypes: string =
    "changetype/getbasechangetypes";
  public static readonly getPreference: string = "getpreferences";
  public static readonly getTypeConstantValues: string =
    "gettypeconstantvalues";
  public static readonly addParticipant: string =
    "participants/addparticipants";
  public static readonly removeParticipant: string =
    "participants/removeparticipants";
  public static readonly opGetFeedback: string = "summarize/feedback";
  public static readonly listObjects: string = "listobjects";
  public static readonly getDeclarativeStyleSheets: string = "stylesheet";
  public static readonly getTaskResults: string = "tasks";
  public static readonly getSimilarPR: string = "similarpr";
  public static readonly opPolarionAuth: string = "polarion/auth/login";
  public static readonly Polarion: string = "Polarion";
  public static readonly development: string = "development";
  // Configuration specific
  public static readonly problemReportType: string = "problemReportType";
  public static readonly openAIOptIn: string = "openAIOptIn";
  public static readonly problemReportFieldsDescription: string =
    "problemReportFieldsDescription";

  // App Type Constants
  public static readonly appType: string = "tcteams";

  // TcVersion Constant
  public static readonly defaultTcVersion: string = "default";
  public static readonly TcVersion2506: number = 2506;
}
